import { Payment } from '@payment/payment-sdk';

const SHOPLINE_PAYMENT_CLIENT_ID = 'EC1.0';

app.directive('checkoutShoplinePaymentV2', [
  'logger',
  'mainConfig',
  'cart',
  'moneyService',
  '$http',
  'pnotifyService',
  '$filter',
  'slFeatureService',
  'creditCard',
  function (
    logger,
    mainConfig,
    cart,
    moneyService,
    $http,
    pnotifyService,
    $filter,
    slFeatureService,
    creditCard,
  ) {
    var countryList = [
      'zh-cn',
      'zh-hant',
      'en',
      'de',
      'ru',
      'fr',
      'es',
      'ja',
      'th',
    ];
    var deviceType = /iPad/.test(navigator.userAgent)
      ? 'pad'
      : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(
          navigator.userAgent,
        )
      ? 'phone'
      : 'pc';
    var paymentMethodMap = {
      credit: 'CreditCard',
      atm_virtual_account: 'VirtualAccount',
      fpx: 'FPX',
      atome: 'AtomeBNPL',
      chailease: 'ChaileaseBNPL',
      alipay: (function (deviceType) {
        return deviceType === 'phone' ? 'AlipayWap' : 'AlipayQrCode';
      })(deviceType),
      unionpay: 'Unionpay',
    };

    return {
      restrict: 'A',
      scope: '=',
      link: function (scope) {
        var getCountry = function (countryCode) {
          var targetCountry = countryList.find(function (country) {
            return countryCode === country;
          });
          if (targetCountry) {
            if (targetCountry === 'zh-hant') {
              return 'zh-TW';
            } else if (targetCountry === 'zh-cn') {
              return 'zh-CN';
            }

            return targetCountry;
          }
          return 'en';
        };
        try {
          const currency = cart
            ? cart.total
            : moneyService.toMoney({
                cents: moneyService.dollarsToCents(
                  1,
                  mainConfig.merchantData.base_currency_code,
                ),
                currency_iso: mainConfig.merchantData.base_currency_code,
              });
          const amount =
            currency.currency_iso === 'TWD'
              ? currency.cents * 100
              : currency.cents;

          var paymentConfig = {
            clientId: SHOPLINE_PAYMENT_CLIENT_ID,
            paymentMethod: cart
              ? paymentMethodMap[
                  cart.payment_method.config_data.shopline_payment_payment
                ]
              : 'CreditCard',
            merchantId: mainConfig.merchantData.sl_payment_merchant_id,
            channelId: 'SLPayments',
            countryCode: mainConfig.merchantData.base_country_code,
            currency: mainConfig.merchantData.base_currency_code,
            language: getCountry(mainConfig.localeData.loadedLanguage.code),
            installmentCounts: cart
              ? cart.payment_method.config_data.installments
              : [],
            amount: amount,
            env: mainConfig.shoplinePaymentV2Env,
            customerToken: '',
            paymentInstrument: {
              bindCard: {
                enable: false,
                protocol: {
                  mustAccept: false,
                  textType: {
                    paymentAgreement: false,
                  },
                  defaultSwitchStatus: false,
                  switchVisible: false,
                },
              },
            },
          };

          const renderCheckoutSDK = function () {
            new Payment(paymentConfig, '#checkout-shopline-payment-v2-form')
              .init()
              .then(function (data) {
                scope.shoplinePaymentV2Content = data;
              });
            scope.shoplinePaymentDeviceType = deviceType;
          };

          if (
            cart &&
            (!slFeatureService.hasFeature('slp_remember_credit_card') ||
              paymentConfig.paymentMethod !== 'CreditCard' ||
              (paymentConfig.installmentCounts &&
                paymentConfig.installmentCounts.length > 0))
          ) {
            renderCheckoutSDK();
            return;
          }

          // only when checkout and slp_remember_credit_card key on and payment type is CreditCard with no installment
          // else go up scope
          if (cart) {
            const promises = ['payment_instruments', 'customer_token'].map(
              (endPoint) =>
                $http({
                  method: 'GET',
                  url: `/api/shopline_payment/${endPoint}`,
                }),
            );
            Promise.all(promises)
              .then(([paymentInstrumentsRes, tokenRes]) => {
                const cardList = paymentInstrumentsRes.data;
                if (tokenRes.data.customer_token) {
                  paymentConfig.customerToken = tokenRes.data.customer_token;
                  paymentConfig.paymentInstrument.bindCard.enable = true;
                  scope.shoplinePaymentSwitchVisible = false;
                }
                if (cardList.length < creditCard.CARD_LIST_LIMIT) {
                  paymentConfig.paymentInstrument.bindCard.protocol.textType.paymentAgreement = true;
                  paymentConfig.paymentInstrument.bindCard.protocol.switchVisible = true;
                  scope.shoplinePaymentSwitchVisible = true;
                }
              })
              .finally(function () {
                renderCheckoutSDK();
              });
            return;
          }

          // for member center bind credit card
          paymentConfig.paymentInstrument.bindCard.protocol.mustAccept = true;
          paymentConfig.paymentInstrument.bindCard.enable = true;
          paymentConfig.paymentInstrument.bindCard.protocol.textType.paymentAgreement = true;
          paymentConfig.paymentInstrument.bindCard.protocol.switchVisible = true;
          new Payment(paymentConfig, '#checkout-shopline-payment-v2-form')
            .init()
            .then(function (data) {
              scope.$emit('shoplinePaymenthasResponse', data);
            });
        } catch (e) {
          logger.error(e);
        }
      },
    };
  },
]);
